import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupPatientExchange(): void {
  applicationModuleRegistry.register({
    entry: 'PATIENT_EXCHANGE#9064',
    id: 'PATIENT_EXCHANGE#9064',
    name: 'module.patient_exchange',
    route: ApplicationRoute.PATIENT_EXCHANGE,
    routes: [
      {
        main: true,
        name: 'function.list-of-patients',
        route: ApplicationRoute.CHANGE_PATIENT_SEARCH,
      }
    ]
  });
}